var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/get-sections.js
var getCartSectionsToRender = (includeRecommendations = true) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const sectionConfig = [
    {
      id: "cart-items",
      section: (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.id,
      selector: "#cart-items"
    },
    {
      id: "mobile-recommendations",
      section: (_b = document.querySelector("cart-drawer")) == null ? void 0 : _b.id,
      selector: "#mobile-recommendations"
    },
    {
      id: "cartdrawer-progress",
      section: (_c = document.querySelector("cart-drawer")) == null ? void 0 : _c.id,
      selector: "#cartdrawer-progress"
    },
    {
      id: "cartdrawer-head",
      section: (_d = document.querySelector("cart-drawer")) == null ? void 0 : _d.id,
      selector: "#cartdrawer-head"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-footer",
      section: (_e = document.querySelector("cart-drawer")) == null ? void 0 : _e.id,
      selector: "#cart-footer"
    },
    {
      id: "desktop-recommendations",
      section: ((_f = document.querySelector(".main-cart__inner")) == null ? void 0 : _f.id) ? (_g = document.querySelector(".main-cart__inner")) == null ? void 0 : _g.id : (_h = document.querySelector("cart-drawer")) == null ? void 0 : _h.id,
      selector: "#desktop-recommendations"
    },
    {
      id: "cart-summary-desktop",
      section: ((_i = document.querySelector(".main-cart__inner")) == null ? void 0 : _i.id) ? (_j = document.querySelector(".main-cart__inner")) == null ? void 0 : _j.id : (_k = document.querySelector("cart-drawer")) == null ? void 0 : _k.id,
      selector: "#cart-summary-desktop"
    },
    {
      id: "cart-items-desktop",
      section: ((_l = document.querySelector(".main-cart__inner")) == null ? void 0 : _l.id) ? (_m = document.querySelector(".main-cart__inner")) == null ? void 0 : _m.id : (_n = document.querySelector("cart-drawer")) == null ? void 0 : _n.id,
      selector: "#cart-items-desktop"
    }
  ];
  const filtered = includeRecommendations ? sectionConfig : sectionConfig.filter((s) => !["mobile-recommendations", "desktop-recommendations"].includes(s.id));
  return {
    sections: filtered.map((item) => item.section).filter(Boolean),
    selectors: filtered.map((item) => item.selector)
  };
};

// src/utils/section-rendering.js
var renderSections = (dom, sectionsArray) => {
  sectionsArray.forEach((section) => {
    const source = dom.querySelector(section);
    const destination = document.querySelector(section);
    if (source && destination)
      destination.outerHTML = source.outerHTML;
  });
};
var section_rendering_default = renderSections;

// src/utils/error-handler.js
var errorHandler = class {
  /**
   * lock the body to prevent scrolling.
   */
  showError(message) {
    const errorMessage = document.querySelector("#error-message");
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "false");
    errorMessage.innerHTML = message;
    setTimeout(() => {
      this.hideError();
    }, 5e3);
  }
  /**
   * unlock the scrolling of the body.
   */
  hideError() {
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "true");
  }
};
var error_handler_default = new errorHandler();

// src/extenders/cart-item.js
var addonUpdateLocks = /* @__PURE__ */ new Set();
var CartItem = class extends HTMLElement {
  /**
   * Initializes local state and pre-bound handler references.
   * DOM lookups and listener attachment are done in connectedCallback.
   */
  constructor() {
    super();
    /**
     * Fetches and re-renders wishlist-related sections in the DOM.
     */
    __publicField(this, "fetchWishlistSections", () => {
      const wishlistId = document.querySelector(".wishlist__inner") !== null ? document.querySelector(".wishlist__inner").id : "main-wishlist";
      const cartItems = document.querySelector(".main-cart__inner") !== null ? document.querySelector(".main-cart__inner").id : "main-cart";
      const url = `${window.location.href}?sections=header,${wishlistId},${cartItems}`;
      fetch(url).then((r) => r.json()).then((data) => {
        const parser = new DOMParser();
        Object.entries(data).forEach(([value]) => {
          const dom = parser.parseFromString(value, "text/html");
          section_rendering_default(dom, this.elementsToReplace);
        });
      });
    });
    this.elementsToReplace = [".utils__wishlist", ".wishlist", "#wishlist-counter", "#cart-items-desktop"];
    this.addonLinkId = this.getAttribute("data-addon-link-id") || "";
    this.key = this.getAttribute("data-key");
    this.increase = null;
    this.decrease = null;
    this.remove = null;
    this.wishlist = null;
    this.productId = null;
    this.customer = null;
    this.giftWrapCheckbox = null;
    this.gemNoteCheckbox = null;
    this.physicalGiftcardProductCheckbox = null;
    this.handleIncreaseClick = () => {
      this.setAttribute("aria-busy", true);
      this.updateQuantity("increase");
    };
    this.handleDecreaseClick = () => {
      this.setAttribute("aria-busy", true);
      this.updateQuantity("decrease");
    };
    this.handleRemoveClick = () => {
      this.setAttribute("aria-busy", true);
      this.removeItem();
    };
    this.handleWishlistClick = () => {
      this.handleWishlist();
    };
    this.handleGiftWrapChange = () => {
      this.setAttribute("aria-busy", true);
      this.updateGiftWrap();
    };
    this.handleGemNoteChange = () => {
      this.setAttribute("aria-busy", true);
      this.updateGemNote();
    };
    this.handlePhysicalGiftcardProductChange = () => {
      this.setAttribute("aria-busy", true);
      this.updatePhysicalGiftcardProduct();
    };
  }
  /**
   * Lifecycle hook: resolves current DOM references and binds listeners.
   */
  connectedCallback() {
    this.refreshElementReferences();
    this.removeEventListeners();
    this.addEventListeners();
  }
  /**
   * Lifecycle hook: removes listeners when element is detached.
   */
  disconnectedCallback() {
    this.removeEventListeners();
  }
  /**
   * Re-resolves interactive element references from the current DOM subtree.
   */
  refreshElementReferences() {
    var _a, _b;
    const elementId = this.getAttribute("id");
    this.key = this.getAttribute("data-key");
    this.addonLinkId = this.getAttribute("data-addon-link-id") || this.addonLinkId || "";
    this.increase = this.querySelector("#quantity-increase");
    this.decrease = this.querySelector("#quantity-decrease");
    this.remove = this.querySelector("#remove");
    this.wishlist = this.querySelector("#wishlist");
    this.productId = (_a = this.wishlist) == null ? void 0 : _a.getAttribute("data-id");
    this.customer = (_b = this.wishlist) == null ? void 0 : _b.getAttribute("data-customer");
    this.giftWrapCheckbox = this.querySelector(`#gift-wrap-${elementId}`);
    this.gemNoteCheckbox = this.querySelector(`#gem-note-${elementId}`);
    this.physicalGiftcardProductCheckbox = this.querySelector(`#physical-giftcard-product-${elementId}`);
  }
  /**
   * Attaches all supported event listeners for this cart item instance.
   */
  addEventListeners() {
    var _a, _b, _c, _d, _e, _f, _g;
    (_a = this.increase) == null ? void 0 : _a.addEventListener("click", this.handleIncreaseClick);
    (_b = this.decrease) == null ? void 0 : _b.addEventListener("click", this.handleDecreaseClick);
    (_c = this.remove) == null ? void 0 : _c.addEventListener("click", this.handleRemoveClick);
    (_d = this.wishlist) == null ? void 0 : _d.addEventListener("click", this.handleWishlistClick);
    (_e = this.giftWrapCheckbox) == null ? void 0 : _e.addEventListener("change", this.handleGiftWrapChange);
    (_f = this.gemNoteCheckbox) == null ? void 0 : _f.addEventListener("change", this.handleGemNoteChange);
    (_g = this.physicalGiftcardProductCheckbox) == null ? void 0 : _g.addEventListener("change", this.handlePhysicalGiftcardProductChange);
  }
  /**
   * Detaches all event listeners previously attached by addEventListeners.
   */
  removeEventListeners() {
    var _a, _b, _c, _d, _e, _f, _g;
    (_a = this.increase) == null ? void 0 : _a.removeEventListener("click", this.handleIncreaseClick);
    (_b = this.decrease) == null ? void 0 : _b.removeEventListener("click", this.handleDecreaseClick);
    (_c = this.remove) == null ? void 0 : _c.removeEventListener("click", this.handleRemoveClick);
    (_d = this.wishlist) == null ? void 0 : _d.removeEventListener("click", this.handleWishlistClick);
    (_e = this.giftWrapCheckbox) == null ? void 0 : _e.removeEventListener("change", this.handleGiftWrapChange);
    (_f = this.gemNoteCheckbox) == null ? void 0 : _f.removeEventListener("change", this.handleGemNoteChange);
    (_g = this.physicalGiftcardProductCheckbox) == null ? void 0 : _g.removeEventListener("change", this.handlePhysicalGiftcardProductChange);
  }
  /**
   * Broadcasts a cart cleanup check event for orphan addon reconciliation.
   */
  triggerCartCleanupCheck() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:cleanup:check"));
  }
  /**
   * Acquires a lock for the current parent addon link id.
   * @returns {string|null} Lock key when acquired, otherwise null
   */
  acquireAddonLock() {
    const lockKey = this.getOrCreateAddonLinkId();
    if (addonUpdateLocks.has(lockKey))
      return null;
    addonUpdateLocks.add(lockKey);
    return lockKey;
  }
  /**
   * Releases a previously acquired addon lock.
   * @param {string|null} lockKey
   */
  releaseAddonLock(lockKey) {
    if (!lockKey)
      return;
    addonUpdateLocks.delete(lockKey);
  }
  /**
   * Renders Shopify section HTML payload into configured cart selectors.
   * @param {Object<string, string>|undefined} sectionsMap
   */
  renderCartSections(sectionsMap, includeRecommendations = true) {
    if (!sectionsMap)
      return;
    const parser = new DOMParser();
    const { selectors } = getCartSectionsToRender(includeRecommendations);
    console.log("[cart-item] renderCartSections \u2014 includeRecommendations:", includeRecommendations, "| selectors:", selectors);
    Object.entries(sectionsMap).forEach(([sectionKey, sectionMarkup]) => {
      const dom = parser.parseFromString(sectionMarkup, "text/html");
      console.log("[cart-item] rendering section:", sectionKey);
      selectors.forEach((sel) => {
        const source = dom.querySelector(sel);
        if (source)
          console.log("[cart-item] found match for selector:", sel, "in section:", sectionKey);
      });
      section_rendering_default(dom, selectors);
    });
  }
  /**
   * Updates the quantity of the cart item.
   * @param {('increase'|'decrease')} action - The action to perform on the quantity
   */
  updateQuantity(action) {
    const quantity = parseInt(this.querySelector("#quantity").textContent);
    const newQuantity = action === "increase" ? quantity + 1 : quantity - 1;
    const { sections } = getCartSectionsToRender(false);
    const data = {
      id: this.key,
      quantity: newQuantity,
      sections
    };
    this.querySelector("#quantity").textContent = newQuantity;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    }).then((r) => r.json().then((d) => r.ok ? d : Promise.reject(new Error(d.message)))).then((json) => {
      this.renderCartSections(json == null ? void 0 : json.sections, false);
      this.triggerCartCleanupCheck();
    }).catch((error) => {
      this.querySelector("#quantity").textContent = quantity;
      error_handler_default.showError(error.message);
    }).finally(() => {
      this.setAttribute("aria-busy", false);
    });
  }
  /**
   * Removes the item from the cart and handles associated gift wrap and gem note removal if necessary.
   */
  async removeItem() {
    const { sections } = getCartSectionsToRender();
    const parentKey = this.key;
    const parentAddonLinkId = this.getAttribute("data-addon-link-id") || this.addonLinkId || "";
    try {
      if (!parentKey)
        throw new Error("Missing cart line key");
      const linkedAddonKeys = await this.resolveLinkedAddonKeys(parentKey, parentAddonLinkId);
      const updates = { [parentKey]: 0 };
      linkedAddonKeys.forEach((key) => {
        updates[key] = 0;
      });
      const r = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates, sections })
      });
      const json = await r.json();
      if (!r.ok)
        throw new Error(json.message || "Failed to remove item from cart");
      this.renderCartSections(json == null ? void 0 : json.sections);
    } catch (error) {
      const errorMessage = error.message || "Failed to remove item from cart";
      console.error("Cart item removal error:", error);
      error_handler_default.showError(errorMessage);
    } finally {
      this.setAttribute("aria-busy", false);
    }
  }
  /**
   * Toggles the current item in the wishlist for logged-in customers.
   */
  handleWishlist() {
    const object = {
      id: this.productId,
      customer: this.customer
    };
    if (this.customer !== "") {
      fetch("https://endeavour.n8p1.hostingsecure.com/webhook/661b1248-9a1f-43ab-a6c1-f10a1512b075", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(object)
      }).then((r) => r.json()).then((data) => {
        if (data.added) {
          this.fetchWishlistSections();
        } else {
          this.fetchWishlistSections();
        }
      });
    }
  }
  /**
   * Adds an addon product to the cart associated with a specific item.
   * @param {HTMLInputElement} checkbox - Checkbox containing addon variant id in data-variant
   * @param {string} addonLinkId - Link id used to associate addon with parent line
   * @param {string} [errorMessage] - Optional error log context
   */
  async addAddonProduct(checkbox, addonLinkId, errorMessage = "Addon line add failed") {
    if (!checkbox)
      return;
    const { sections } = getCartSectionsToRender();
    const variantId = parseInt(checkbox.getAttribute("data-variant") || "", 10);
    if (!variantId)
      return;
    const existingKey = await this.resolveAddonLineKey(variantId, addonLinkId);
    if (existingKey) {
      return;
    }
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: checkbox.getAttribute("data-variant"),
          quantity: 1,
          properties: {
            _belongs_to_link_id: addonLinkId
          },
          sections
        })
      });
      const json = await r.json();
      if (!r.ok)
        throw new Error(json.message);
      this.renderCartSections(json == null ? void 0 : json.sections);
      this.triggerCartCleanupCheck();
    } catch (error) {
      console.error(errorMessage, error);
    }
  }
  /**
   * Removes an addon product from the cart.
   * @param {string} key - The cart item key of the addon to remove
   * @param {string} [errorMessage] - Optional error log context
   */
  async removeAddonProduct(key, errorMessage = "Addon line remove failed") {
    const { sections } = getCartSectionsToRender();
    try {
      const r = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0, sections })
      });
      const json = await r.json();
      if (!r.ok)
        throw new Error(json.message);
      this.renderCartSections(json == null ? void 0 : json.sections);
      this.triggerCartCleanupCheck();
    } catch (error) {
      console.error(errorMessage, error);
    }
  }
  /**
   * Resolves addon line keys linked to a parent cart line.
   * Supports both `_belongs_to_link_id` and legacy `_belongs_to` linkage.
   * @param {string} parentKey
   * @param {string} parentAddonLinkId
   * @returns {Promise<string[]>}
   */
  resolveLinkedAddonKeys(parentKey, parentAddonLinkId) {
    return fetch("/cart.js").then((r) => r.json()).then((cart) => {
      const items = (cart == null ? void 0 : cart.items) || [];
      const linkedKeys = items.filter((item) => {
        var _a, _b;
        const belongsToLinkId = (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._belongs_to_link_id;
        const legacyBelongsTo = (_b = item == null ? void 0 : item.properties) == null ? void 0 : _b._belongs_to;
        if (parentAddonLinkId && belongsToLinkId) {
          return belongsToLinkId === parentAddonLinkId;
        }
        if (parentKey && legacyBelongsTo) {
          return legacyBelongsTo === parentKey;
        }
        return false;
      }).map((item) => item.key).filter(Boolean);
      return Array.from(new Set(linkedKeys));
    }).catch((error) => {
      console.error("Failed resolving linked addon keys", error);
      return [];
    });
  }
  /**
   * Returns an existing addon link id or creates a new one for this line.
   * @returns {string}
   */
  getOrCreateAddonLinkId() {
    if (this.addonLinkId && this.addonLinkId !== "")
      return this.addonLinkId;
    this.addonLinkId = `addon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    return this.addonLinkId;
  }
  /**
   * Builds line item properties reflecting current addon checkbox states.
   * @returns {{_addon_link_id: string, _gift_wrap?: string, _gem_note?: string}}
   */
  getProperties() {
    const properties = {};
    properties._addon_link_id = this.getOrCreateAddonLinkId();
    if (this.giftWrapCheckbox) {
      properties._gift_wrap = this.giftWrapCheckbox.checked.toString();
    }
    if (this.gemNoteCheckbox) {
      properties._gem_note = this.gemNoteCheckbox.checked.toString();
    }
    return properties;
  }
  /**
   * Resolves an addon line key by variant and parent addon link id.
   * @param {number} addonVariantId
   * @param {string} addonLinkId
   * @returns {Promise<string>}
   */
  resolveAddonLineKey(addonVariantId, addonLinkId) {
    return fetch("/cart.js").then((r) => r.json()).then((cart) => {
      const items = (cart == null ? void 0 : cart.items) || [];
      const linked = items.find((item) => {
        var _a;
        return item.id === addonVariantId && ((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._belongs_to_link_id) === addonLinkId;
      });
      return (linked == null ? void 0 : linked.key) || "";
    }).catch((error) => {
      console.error("Failed resolving addon line key", error);
      return "";
    });
  }
  /**
   * Resolves the current product line key from a cart response.
   * Avoids relying on stale rendered row position when addon rows exist.
   * @param {Object} response
   * @returns {string}
   */
  resolveCurrentProductKeyFromResponse(response) {
    var _a, _b, _c;
    const items = (response == null ? void 0 : response.items) || [];
    const productVariantId = parseInt(this.id, 10);
    const matched = items.filter((item) => item.id === productVariantId);
    if (matched.length === 1) {
      this.key = matched[0].key;
      this.addonLinkId = ((_b = (_a = matched[0]) == null ? void 0 : _a.properties) == null ? void 0 : _b._addon_link_id) || this.addonLinkId;
      return matched[0].key;
    }
    const desiredGem = this.gemNoteCheckbox ? this.gemNoteCheckbox.checked.toString() : null;
    const desiredGift = this.giftWrapCheckbox ? this.giftWrapCheckbox.checked.toString() : null;
    const propertyMatched = matched.find((item) => {
      var _a2, _b2;
      const gemMatches = desiredGem === null || ((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._gem_note) === desiredGem;
      const giftMatches = desiredGift === null || ((_b2 = item == null ? void 0 : item.properties) == null ? void 0 : _b2._gift_wrap) === desiredGift;
      return gemMatches && giftMatches;
    });
    if (propertyMatched == null ? void 0 : propertyMatched.key) {
      this.key = propertyMatched.key;
      this.addonLinkId = ((_c = propertyMatched == null ? void 0 : propertyMatched.properties) == null ? void 0 : _c._addon_link_id) || this.addonLinkId;
      return propertyMatched.key;
    }
    return this.key;
  }
  /**
   * Resolves the current parent product line key from live cart state.
   * Prefers matching by addon link id and falls back to same-variant heuristics.
   * @returns {Promise<string>}
   */
  resolveCurrentProductKeyFromCart() {
    const addonLinkId = this.getOrCreateAddonLinkId();
    const productVariantId = parseInt(this.id, 10);
    return fetch("/cart.js").then((r) => r.json()).then((cart) => {
      var _a, _b, _c;
      const items = (cart == null ? void 0 : cart.items) || [];
      const linked = items.find((item) => {
        var _a2;
        return item.id === productVariantId && ((_a2 = item == null ? void 0 : item.properties) == null ? void 0 : _a2._addon_link_id) === addonLinkId;
      });
      if (linked == null ? void 0 : linked.key) {
        this.key = linked.key;
        this.addonLinkId = ((_a = linked == null ? void 0 : linked.properties) == null ? void 0 : _a._addon_link_id) || this.addonLinkId;
        return linked.key;
      }
      const sameVariant = items.filter((item) => item.id === productVariantId);
      if (sameVariant.length === 1) {
        this.key = sameVariant[0].key;
        this.addonLinkId = ((_c = (_b = sameVariant[0]) == null ? void 0 : _b.properties) == null ? void 0 : _c._addon_link_id) || this.addonLinkId;
        return sameVariant[0].key;
      }
      return this.key;
    }).catch((error) => {
      console.error("Failed to resolve product key from live cart", error);
      return this.key;
    });
  }
  /**
   * Shared flow for updating addon checkbox state and linked addon line items.
   * @param {Object} options
   * @param {HTMLInputElement} options.checkbox
   * @param {string} options.lockType
   * @param {string} options.updateErrorMessage
   * @param {string} options.addErrorMessage
   * @param {string} options.removeErrorMessage
   */
  async updateAddonOption({ checkbox, lockType, updateErrorMessage, addErrorMessage, removeErrorMessage }) {
    if (!checkbox)
      return;
    const lockKey = this.acquireAddonLock(lockType);
    if (!lockKey) {
      checkbox.checked = !checkbox.checked;
      this.setAttribute("aria-busy", false);
      return;
    }
    checkbox.disabled = true;
    try {
      const { sections } = getCartSectionsToRender();
      const currentKey = await this.resolveCurrentProductKeyFromCart();
      const data = {
        id: currentKey,
        quantity: parseInt(this.querySelector("#quantity").textContent),
        properties: this.getProperties(),
        sections
      };
      const r = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
      const json = await r.json();
      if (!r.ok)
        throw new Error(json.message);
      this.resolveCurrentProductKeyFromResponse(json);
      const addonLinkId = this.getOrCreateAddonLinkId();
      if (checkbox.checked) {
        await this.addAddonProduct(checkbox, addonLinkId, addErrorMessage);
      } else {
        const addonVariantId = parseInt((checkbox == null ? void 0 : checkbox.getAttribute("data-variant")) || "", 10);
        const addonKeyToRemove = await this.resolveAddonLineKey(addonVariantId, addonLinkId);
        if (addonKeyToRemove) {
          await this.removeAddonProduct(addonKeyToRemove, removeErrorMessage);
        }
      }
      this.triggerCartCleanupCheck();
    } catch (error) {
      error_handler_default.showError((error == null ? void 0 : error.message) || updateErrorMessage);
      checkbox.checked = !checkbox.checked;
    } finally {
      this.setAttribute("aria-busy", false);
      checkbox.disabled = false;
      this.releaseAddonLock(lockKey);
    }
  }
  /**
   * Updates the gift wrap status for the cart item and handles associated product changes.
   */
  async updateGiftWrap() {
    await this.updateAddonOption({
      checkbox: this.giftWrapCheckbox,
      lockType: "gift-wrap",
      updateErrorMessage: "Gift wrap update failed",
      addErrorMessage: "Gift wrap line add failed",
      removeErrorMessage: "Gift wrap line remove failed"
    });
  }
  /**
   * Updates the gem note status for the cart item and handles associated product changes.
   */
  async updateGemNote() {
    await this.updateAddonOption({
      checkbox: this.gemNoteCheckbox,
      lockType: "gem-note",
      updateErrorMessage: "Gem note update failed",
      addErrorMessage: "Gem note line add failed",
      removeErrorMessage: "Gem note line remove failed"
    });
  }
  /**
   * Replaces the current line with a selected physical gift card variant.
   */
  updatePhysicalGiftcardProduct() {
    const { sections } = getCartSectionsToRender();
    const currentQuantity = parseInt(this.querySelector("#quantity").textContent);
    this.physicalGiftcardProductCheckbox.disabled = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: this.key, quantity: 0, sections })
    }).then((r) => r.json().then((d) => r.ok ? d : Promise.reject(new Error(d.message)))).then(() => {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: this.physicalGiftcardProductCheckbox.getAttribute("data-variant"),
          quantity: currentQuantity,
          sections
        })
      }).then((r) => r.json().then((d) => r.ok ? d : Promise.reject(new Error(d.message))));
    }).then((data) => {
      this.renderCartSections(data == null ? void 0 : data.sections);
    }).catch((error) => {
      error_handler_default.showError(error.message);
      this.physicalGiftcardProductCheckbox.checked = !this.physicalGiftcardProductCheckbox.checked;
    }).finally(() => {
      this.setAttribute("aria-busy", false);
      this.physicalGiftcardProductCheckbox.disabled = false;
    });
  }
};
if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}
